import { countries } from '@/app/account/update-my-details/client/countries'
import { getTopics } from '@/app/account/update-my-details/client/topics'

export type AccountField = {
  label?: string
  type?: 'text' | 'email' | 'select' | 'checkbox' | 'radio' | 'textarea'
  required?: boolean
  choices?: { label: string; value: string }[]
  classNames?: {
    field?: string
    input?: string
  }
}

export type AccountFieldNames = keyof ReturnType<typeof getAccountFields>

export type AccountFields = {
  [K in keyof ReturnType<typeof getAccountFields>]?: AccountField
}

export const getAccountFields = async () => {
  return {
    first_name: {
      label: 'First Name',
      type: 'text',
      required: true,
    },
    last_name: {
      label: 'Last Name',
      type: 'text',
      required: true,
    },
    job_title: {
      label: 'Job Title',
      type: 'text',
    },
    phone: {
      label: 'Phone',
      type: 'text',
    },
    city: {
      label: 'City',
      type: 'text',
    },
    country: {
      label: 'Country',
      type: 'select',
      choices: countries,
      required: true,
    },
    custom_feed_topics: {
      label: 'Topics',
      type: 'grouped_checkbox',
      choices: await getTopics(),
      classNames: {
        field: 'col-span-2',
        input: 'grid grid-cols-2 gap-x-s gap-y-xxs s:grid-cols-1 [&_label]:font-normal',
      },
    },
  }
}
